<mat-select class="multi-select" [(ngModel)]="selection" multiple (selectionChange)="setValue($event)"> 
  @for(option of options; track option) {
    <mat-option [value]="option.name">
      {{option.name}}
    </mat-option>
  }  
  </mat-select>  